import { teacherAuthInfo } from "@/api/teacher/auth";
import { setStore, getStore, removeStore } from "./util";

const USER_INFO_KEY = "userInfo";

export function setUserInfo(info) {
  if (!info) return;
  setStore(USER_INFO_KEY, info);
}

export function getUserInfo() {
  const raw = getStore(USER_INFO_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function clearUserInfo() {
  removeStore(USER_INFO_KEY);
}

/** 归一化教师 auth/info */
export function normalizeTeacherAuthInfo(payload = {}) {
  const root = payload || {};
  const user = root.user || root.teacher || root.teacherInfo || root;
  const roles = root.roles || user.roles || [];
  const permissions = root.permissions || user.permissions || [];

  return {
    ...user,
    userName: user.account || user.userName || user.username || "",
    nickName:
      user.teacherName || user.nickName || user.userName || user.account || "",
    avatar: user.avatar || "",
    phonenumber: user.mobile || user.phonenumber || "",
    email: user.email || "",
    teacherId: user.teacherId != null ? user.teacherId : user.id,
    teacherCode: user.teacherCode,
    teacherType: user.teacherType,
    teacherTitle: user.teacherTitle,
    roles,
    permissions
  };
}

export function pickAccessToken(data = {}) {
  return (
    data.access_token ||
    data.accessToken ||
    data.token ||
    (data.data &&
      (data.data.access_token || data.data.accessToken || data.data.token)) ||
    ""
  );
}

export async function fetchAndSaveUserInfo() {
  const result = await teacherAuthInfo();
  const data = normalizeTeacherAuthInfo(result.data || {});
  setUserInfo(data);
  return data;
}

export function getUserRoles() {
  const info = getUserInfo();
  return (info && info.roles) || [];
}

export function getUserRoleKeys() {
  const roles = getUserRoles();
  return roles
    .map(item => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return item.roleKey || item.role_key || item.key || "";
    })
    .filter(Boolean);
}



// WEBPACK FOOTER //
// ./src/utils/userInfo.js